var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEligible1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 20H44",
    stroke: "#4F8AFB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1005 41H12.8805C5.78049 41 3.98047 39.24 3.98047 32.22V15.78C3.98047 9.42003 5.46053 7.38003 11.0405 7.06003C11.6005 7.04003 12.2205 7.02002 12.8805 7.02002H35.1005C42.2005 7.02002 44.0005 8.78002 44.0005 15.8V24.62",
    stroke: "#4F8AFB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12 32H20",
    stroke: "#4F8AFB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M44 36C44 37.5 43.58 38.92 42.84 40.12C41.46 42.44 38.92 44 36 44C33.08 44 30.54 42.44 29.16 40.12C28.42 38.92 28 37.5 28 36C28 31.58 31.58 28 36 28C40.42 28 44 31.58 44 36Z",
    stroke: "#4F8AFB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M32.8789 36L34.8589 37.98L39.1189 34.04",
    stroke: "#4F8AFB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEligible1);
export default __webpack_public_path__ + "static/media/eligible1.942dd85b296adcb454e4a95f91f5a231.svg";
export { ForwardRef as ReactComponent };